export const SINGLE_LINE_CLASS = 'single-line';
export const COMMENT_CELL_CLASS = 'comment-cell';
